export const requestBodyExample = `{
  "userId": "90", // optional - user identifier if authenticated
  "sessionId": "sess456"
}`;
